export default __webpack_public_path__ + "static/media/88.64ab5393.jpg";